module.exports = __webpack_public_path__ + "static/media/shop2.a17d0cba.jpg";